/** @jsxImportSource theme-ui @jsxRuntime classic */
import { Box, Link } from '@tishman/components';
import React from 'react';

interface SidebarMenuItemProps {
  isActive: boolean;
  slug: string;
  title: string;
}

const SidebarMenuItem = ({ isActive, slug, title }: SidebarMenuItemProps) => {
  return (
    <Box
      as="li"
      sx={{
        mb: '26px',
        fontSize: '14px',
      }}
    >
      <Link
        href={`#${slug}`}
        sx={{
          '&:hover': {
            span: {
              borderBottom: 'none',
              backgroundSize: isActive ? '100%' : '0',
            },
          },
        }}
        variant="sidebarMenuUnderline"
      >
        <Box
          as="span"
          sx={{
            borderBottom: isActive ? '2px solid currentColor' : 'none',
          }}
        >
          {title}
        </Box>
      </Link>
    </Box>
  );
};

interface SideBarMenuProps {
  categories: Queries.BuyTicketsQuery['allSanityTicketCategory']['nodes'];
  category: Queries.BuyTicketsQuery['allSanityTicketCategory']['nodes'][0];
}

export function SidebarMenu({
  categories,
  category,
}: SideBarMenuProps): React.JSX.Element {
  return (
    <Box
      as="ul"
      sx={{
        pl: '16px',
      }}
    >
      {categories.map((c) => (
        <SidebarMenuItem
          isActive={c.id === category.id}
          key={c.id}
          slug={c.slug?.current ?? ''}
          title={c.title ?? ''}
        />
      ))}
    </Box>
  );
}
